// Favicon je importovaná z `assets/`, takže jí Vite do názvu vloží hash
// odvozený z obsahu (např. `/_nuxt/favicon.<hash>.png`). Jakmile se obrázek
// v budoucnu změní, změní se i hash → nová URL → prohlížeč si v záložkách
// při dalším načtení stáhne novou ikonu a neservíruje starou z cache.
// Není tedy potřeba ručně verzovat název souboru. Viz doc/favicon.md
import faviconUrl from '~/assets/images/favicon.png'

export default defineNuxtPlugin(() => {
    useHead({
        link: [{ rel: 'icon', type: 'image/png', href: faviconUrl }],
    })
})
